import { render, staticRenderFns } from "./Rome.vue?vue&type=template&id=077bf5b0&"
import script from "./Rome.vue?vue&type=script&lang=js&"
export * from "./Rome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports